import React from 'react'
import axios from 'axios'
import Icon from 'Core/Components/Icon'

import { SERVER_URL } from 'RLX/Config'

import { AssetController } from './AssetController'
import { AssetsTableView } from './AssetsTableView'
import { AssetsTileView } from './AssetsTileView'

import { PaneHeader, SectionTitle } from 'Dashboard/Panes/Common'
import { getQueryParams, setQueryParam, getAssetAttributes, getIconForAsset, assetsViewLayoutTypes, transformAssetList } from './assets-utils'

class AssetsListView extends AssetController {
    constructor (props) {
        super(props)

        this.render = this.render.bind(this);
    }

    render () {
        const filteredAssets = this.getFilteredAssets();
        const breadcrumbs = this.getBreadcrumbs();

        return (
            <div className="AssetsListView grid-fluid" style={{ padding: '0 20px' }}>
                <SectionTitle pane="File Manager" icon="folder-o"/>

                {/* TOOLBAR */}
                <div className="row" style={{ backgroundColor: 'rgba(0, 0, 0, 0.05)', margin: '10px 0 0', padding: 10, alignItems: 'center', flexWrap: 'nowrap' }}>
                    {/* BREADCRUMBS */}
                    <div style={{ flexGrow: 1 }}>

                        <button
                            style={{ backgroundColor: '#efefef', paddingLeft: 12, paddingRight: 12, marginRight: 0 }}
                            onClick={() => this.goToParentDirectory()}
                            disabled={this.state.activeDirectory === '/assets'}>
                            <Icon fa="arrow-up" style={{ transform: 'scale(1.3)' }} />
                        </button>
                        <button
                            style={{ backgroundColor: '#efefef', paddingLeft: 12, paddingRight: 12 }}
                            onClick={() => this.selectDirectory('/assets')}
                            disabled={this.state.activeDirectory === '/assets'}>
                            <Icon fa="home" style={{ transform: 'scale(1.5)', transformOrigin: 'center top' }} />
                        </button>
                        <span style={{ margin: 10, color: '#AAA' }}>
                            <Icon fa="folder-open-o" style={{ transform: 'scale(1.3)' }} />
                        </span>
                        {breadcrumbs.map((crumb, index) => (
                            <div key={index} style={{ display: 'inline-block' }}>
                                <button onClick={() => this.selectDirectory(crumb.path)} key={index} style={{ backgroundColor: '#efefef', borderTopRightRadius: 0, borderBottomRightRadius: 0 }}>
                                    {crumb.name}
                                </button>
                                <button style={{ backgroundColor: '#efefef', pointerEvents: 'none', paddingLeft: 3, paddingRight: 3, marginLeft: -6, marginRight: -4, borderTopLeftRadius: 0, borderBottomLeftRadius: 0, color: '#CCC' }}>
                                    /
                                </button>
                            </div>
                        ))}
                    </div>
                    {/* TOOLBAR RIGHT */}
                    <div>
                        <button
                            style={{ backgroundColor: '#efefef' }}
                            onClick={() => this.createNewDirectory()}>
                            <Icon fa="plus-circle" style={{ marginRight: 10 }}/>
                            New Folder
                        </button>
                        <button
                            onClick={() => this.selectLayout(assetsViewLayoutTypes.TILE)}
                            style={this.state.layout === assetsViewLayoutTypes.TILE ? { backgroundColor: 'white', color: 'black' } : {} }>
                            <Icon style={{ transform: 'scale(2)', marginBottom: -14, padding: 0, display: 'inline-block' }} fa="table"/>
                        </button>
                        <button
                            onClick={() => this.selectLayout(assetsViewLayoutTypes.LIST)}
                            style={this.state.layout === assetsViewLayoutTypes.LIST ? { backgroundColor: 'white', color: 'black' } : {} }>
                            <Icon style={{ transform: 'scale(2)', marginBottom: -14, padding: 0, display: 'inline-block' }} fa="list-alt"/>
                        </button>
                    </div>
                </div>

                <div className="row" style={{backgroundColor: 'rgba(0, 0, 0, 0.05)', margin: '5px 0',  padding: 0 }}>

                    {/* FILTER BAR */}
                    <div style={{ display: 'flex', flex: '1 1 33%', padding: 5, alignItems: 'center', flexWrap: 'nowrap', minWidth: 300 }}>
                        <Icon
                            fa="filter"
                            style={{fontSize: 22, margin: '0 10px', color: 'rgb(228, 153, 149)' }}
                        />
                        <input
                            value={this.state.filterQuery}
                            style={{ fontSize: 20, flex: 1, padding: 8, background: 'transparent', border: '1px solid silver', borderRadius: 4, width: '100%' }}
                            onChange={evt => this.onFilterQueryChange(evt.target.value)}
                            autoFocus={true}
                            placeholder="Filter items..."
                        />
                        <span onClick={() => this.onFilterQueryChange('')} title="Clear filter" style={{ cursor: 'pointer' }}>
                            <Icon
                                fa="times"
                                style={{ pointer: 'cursor', fontSize: 32, margin: '0 10px', color: 'silver' }}
                            />
                        </span>
                    </div>


                    {/* UPLOAD BAR */}
                    <div
                        style={{ display: 'flex', padding: 10, flex: '1 0 66%', position: 'relative' }}>
                        <div style={{ display: 'flex', width: '100%', justifyContent: 'center', alignItems: 'flex-start', flexDirection: 'row', border: '2px dashed silver', height: '100%', padding: '10px 5px', cursor: 'pointer' }}>
                            <Icon style={{ fontSize: 30, marginTop: 5, marginLeft: 5, marginRight: 15, color: 'rgb(228, 153, 149)' }} fa={'cloud-upload'}/>
                            <div>
                                <div className="f-row items-end">
                                    <h4 style={{ margin: 0, padding: 0, marginRight: 5, marginBottom: 0, paddingBottom: 0 }}>Click here or drop files to upload</h4>
                                    <p style={{ fontSize: 13, padding: 0, margin: 0, marginTop: -4, marginRight: 5 }}>to <u>{this.state.activeDirectory}</u></p>
                                </div>
                                <p style={{ fontSize: 11, maxWidth: 800, lineHeight: '14px', padding: 0, margin: 0, marginTop: 0, fontWeight: 300, marginRight: 5 }}>File types: {this.state.uploadTypes.join(', ')}</p>
                            </div>
                            <input
                                onChange={this.onFileInputChange}
                                ref={this.ref}
                                multiple
                                type="file"
                                accept={this.state.uploadTypes.map(t => `.${t}`).join(',')}
                                style={{position: 'absolute', opacity: 0.01, width: '100%', height: '100%', cursor: 'pointer' }}
                            />
                        </div>
                    </div>
                </div>

                {!this.state.dataLoaded
                    ? (
                        <div className="row" style={{ padding: '30vh 30px', justifyContent: 'center', textAlign: 'center' }}>
                            <img src="/assets/load-black.gif" />
                        </div>
                    )
                    : filteredAssets.length === 0
                        ? (
                            <div className="EmptyState tc" style={{ padding: '20vh 15px' }}>
                                <Icon fa={'folder-open-o'} style={{fontSize: 70}} />
                                <h2 style={{padding:0, margin:0}}>No files</h2>
                                <p>Sorry, no files exist that match your filter criteria.</p>
                             </div>
                        )
                        : this.state.layout === assetsViewLayoutTypes.TILE
                            ? <AssetsTileView
                                assets={filteredAssets}
                                selection={this.state.selection}
                                onFileDelete={this.onFileDelete}
                                onFileRename={this.onFileRename}
                                onDirectoryRename={this.onDirectoryRename}
                                onDirectoryDelete={this.onDirectoryDelete}
                                onSelectDirectory={this.selectDirectory}
                                onSelectionChange={selection => this.setState({ ...this.state, selection })}
                            />
                            : <AssetsTableView
                                assets={filteredAssets}
                                selection={this.state.selection}
                                onFileDelete={this.onFileDelete}
                                onFileRename={this.onFileRename}
                                onDirectoryRename={this.onDirectoryRename}
                                onDirectoryDelete={this.onDirectoryDelete}
                                onSelectDirectory={this.selectDirectory}
                                onSelectionChange={selection => this.setState({ ...this.state, selection })}
                            />
                }
            </div>
        )
    }
}

export default AssetsListView



// WEBPACK FOOTER //
// ./client/RLX/Views/Dashboard/Panes/Assets/AssetsListView.jsx